<script setup lang="ts">
defineProps({
  label: {
    type: String,
    default: 'label text',
  },
  placeholder: {
    type: String,
    default: 'placeholder text',
  },
  id: {
    type: String,
    default: 'name',
  },
  invalid: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: null,
  },
})
</script>

<template>
  <div>
    <label :for="id">{{ label }}</label>
    <InputText
      :id="id"
      :placeholder="placeholder"
      class="w-full"
      :invalid="invalid"
      autocomplete="off"
      :="$attrs"
    />
    <Message v-if="invalid" variant="simple" size="small" severity="error">
      {{ errorMessage }}
    </Message>
  </div>
</template>
